import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";
import { homeRoute, loginRoute } from "src/app/core/routing/route-names";
import { ActivationGuardBase } from "./activation-guard.base";

@Injectable({
  providedIn: 'root'
})
export class UserAdministrationGuard extends ActivationGuardBase {
  constructor(private authService: AuthService, private router: Router) {
    super();
  }

  checkLogin(url: string): boolean {
    // asset admin and asset storage admin needs to be able to add and remove users with asset group roles
    if (this.authService.isUserLoggedIn() && this.authService.isUserAdminOrConfigurationAdminOrAssetAdmin()) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.authService.redirectUrl = url;

    // Navigate to the login page with extras
    if (this.authService.isUserLoggedIn()) {
      this.router.navigate([homeRoute]);
    } else {
      this.router.navigate([loginRoute]);
    }
    return false;
  }
}
